import React, { useContext, useState } from 'react'
import styles from './SignupLogin.module.css';
import { useLocation } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'
import { Usercontext } from '../App';

export default function Order() {

    // const navigate = useNavigate();
    const location = useLocation();
    const { userdata } = useContext(Usercontext)


    const { name, size, segment } = location.state || {}
    const [price, setprice] = useState((size && size[0]?.price) || 0)
    const [order, setOrder] = useState({
        capacity: size?.[0]?.capacity || 0,
        productName: name || "ProductName",
        segment: segment || "",
        price: size?.[0]?.price || 0,
        address: "",
        city: "ahmedabad",
    });



    const handleOnChange = (name, value) => {
        setOrder((prev) => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const saveOrder = async () => {

        console.log("UIDSSS", userdata?.uid)
        if (order.address !== '' && order.city !== '') {
            const collection = firebase.firestore().collection("Orders")
            collection.doc().set({ ...order, uid: userdata?.uid }).then(() => {
                alert("Order Placed Successfully")
            })
        }
        else
            alert("Please Fill all Fileds")


    }

    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.titleText}>
                    <div className={styles.title}>Orders</div>
                </div>
                <div className={styles.SignupLogin}>


                    <div className={styles.formInner}>
                        <form className={styles.active}>
                            <label>Product Name : </label>
                            <div className={styles.field}>
                                <input type="text" value={name || "Product Name"} name='productname'
                                    // onChange={({ target }) => {
                                    //     handleOnChange(target.name, target.value)
                                    // }} 
                                    disabled />
                            </div>
                            <label>Segment :</label>
                            <div className={styles.field}>
                                <input type="text" name="segment" value={segment} disabled />
                            </div>
                            <div className={styles.field}>
                                <input type="text" name="city" required placeholder='City'
                                    onChange={({ target }) => {
                                        handleOnChange(target.name, target.value)
                                    }}
                                />
                            </div>

                            <div className={styles.field} style={{ width: '100%' }}>
                                <textarea required type="text" name="address" placeholder='Address'
                                    onChange={({ target }) => {
                                        handleOnChange(target.name, target.value)
                                    }}

                                />
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label style={{ fontSize: "16px", fontWeight: "bold", color: "#333", display: "block", marginBottom: "8px" }}>
                                    Select Capacity
                                </label>
                                <select
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                        fontSize: "14px",
                                        backgroundColor: "#f9f9f9",
                                        color: "#333",
                                        cursor: "pointer",
                                        outline: "none",
                                        transition: "border-color 0.3s, box-shadow 0.3s",
                                    }}
                                    onChange={(e) => {
                                        setprice(e.target.value);
                                        handleOnChange("price", parseInt(e.target.value));
                                        handleOnChange("capacity", parseInt(e.target.name));
                                    }}
                                    name="cars"
                                    id="cars"
                                >
                                    {size?.map((sizeItem, index) => (
                                        <option
                                            key={index}
                                            name={sizeItem.capacity}
                                            value={sizeItem.price}
                                            style={{
                                                padding: "10px",
                                                backgroundColor: "#fff",
                                                color: "#333",
                                            }}
                                        >
                                            {sizeItem.capacity}
                                        </option>
                                    ))}
                                </select>
                                <div style={{ marginTop: "15px", fontSize: "16px", fontWeight: "bold", color: "#333" }}>
                                    Price: <span style={{ color: "#007BFF" }}>Rs. {price}</span>
                                </div>
                            </div>


                            <div className={`${styles.field} ${styles.btn}`}>
                                <input type="button" value="Order" onClick={saveOrder} />
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
